<template>
  <div v-if="added.typeSpecific.nextEvent">

    <p v-if="!added.typeSpecific.nextEvent.isLast && added.typeSpecific.nextEvent.strikeHit">
      Bei einem unveränderten Basiswertkurs kommt es zu einer vorzeitigen
      Auszahlung am <span v-html="this.$options.filters.date(added.typeSpecific.nextEvent.date)"></span>
      in Höhe von <span v-html="this.$options.filters.currecy(added.typeSpecific.nextEvent.payoff, 'EUR')"></span>
    </p>
    <p v-if="!added.typeSpecific.nextEvent.isLast && !added.typeSpecific.nextEvent.strikeHit">
      Bei einem unveränderten Basiswertkurs kommt es zu keiner vorzeitigen
      Rückzahlung am <span v-html="this.$options.filters.date(added.typeSpecific.nextEvent.date)"></span>.
    </p>

    <p v-if="added.typeSpecific.nextEvent.isLast && added.typeSpecific.nextEvent.strikeHit">
      Bei einem unveränderten Basiswertkurs kommt es am letzten Bewertungstag zu einer Rückzahlung
      in Höhe von <span v-html="this.$options.filters.currency(added.typeSpecific.nextEvent.payoff, 'EUR')"></span> am
      <span v-html="this.$options.filters.date(added.typeSpecific.nextEvent.date)"></span>
    </p>

    <p
      v-if="added.typeSpecific.nextEvent.isLast && !added.typeSpecific.nextEvent.strikeHit && !product.specific.barrier">
      Bei einem unveränderten Basiswertkurs kommt es zu keiner Rückzahlung und es droht am
      Laufzeitende ein Nennwertverlust.
    </p>

    <p
      v-if="added.typeSpecific.nextEvent.isLast && !added.typeSpecific.nextEvent.strikeHit && product.specific.barrier && product.specific.barrierHit">
      Bei einem unverändertem Basiswertkurs droht ein Nennwertverlust, da die Kursschwelle bereits berührt wurde.
    </p>

    <p
      v-if="added.typeSpecific.nextEvent.isLast && !added.typeSpecific.nextEvent.strikeHit && product.specific.barrier && !product.specific.barrierHit">
      Bei einem unveränderten Basiswertkurs erfolgt die Rückzahlung in Höhe des Nennbetrags.
    </p>

  </div>
</template>

<script>
export default {
  name: 'payback-express',
  props: {
    product: {
      type: Object,
      required: true
    },
    added: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// PaybackExpress.vue?c7f1c75a